export const annotationFilterStatuses = [
  'all',
  'pending',
  'annotated',
  'approved',
  'skipped',
] as const;
export type AnnotationFilterStatus = (typeof annotationFilterStatuses)[number];
export type AnnotationFilterEasy = 'all' | 'yes' | 'no';

export type AnnotationTool = 'arrow' | 'pen';

export enum AnnotationToolEnum {
  ARROW = 'arrow',
  PEN = 'pen',
}

export enum AnnotationStatusEnum {
  PENDING = 'Pending',
  ANNOTATED = 'Annotated',
  APPROVED = 'Approved',
  CHANGEREQUESTED = 'ChangeRequested',
  SKIPPED = 'Skipped',
}
